export const isTruthyOrZero = (value: undefined) => {
  return !(value === null || value === undefined || value === '' || value === false || isNaN(value));
};
